// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__141T3","label":"Category_label__2SD64","content":"Category_content__2CP70","header":"Category_header__2fenu","location":"Category_location__2NkAJ"};